<template>
    <div class="diagram-content-box">
        <div class="diagram-f-title">求测何事</div>
        <div class="diagram-f-item">
            <input class="diagram-f-input" @input="inputChange" type="text" placeholder="输入本命年、男女及所测之事描述" maxlength="50" v-model="formData.d_title">
        </div>
        <div class="diagram-f-title">起卦时间</div>
        <div class="diagram-f-item bb">
            <div class="diagram-f-word" @click="clickTime">{{formData.d_timeStr}}</div>
            <div class="diagram-pos-right" @click="clickNow">
                <i class="dg-icon-jin iconfont icon-jin"></i>
            </div>
        </div>
        <div class="diagram-f-title">起卦方式</div>
        <div class="diagram-f-item" :class="{'diable': this.parentNode && this.parentNode.name == 'DiagramEdit'}" @click="clickChoose">
            <div class="diagram-f-word">{{curDiagramChooseTypeData.text}}</div>
            <div class="diagram-pos-right">
                <i class="dg-icon iconfont icon-xiangyou"></i>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DiagramForm',
    props: {
        parentNode: {
            type: Object,
            default() { return {} } 
        }
    },
    computed: {
        formData() {
            return this.$store.state.diagram.formData;
        },
        curDiagramChooseTypeData() {
            return this.$store.state.diagram.curDiagramChooseTypeData;
        },
    },
    data() {
        return {

        }
    },
    methods: {
        inputChange() {
            if(this.parentNode && this.parentNode.name == 'DiagramEdit') {
                this.$store.state.diagram.formDataEdited = true;
            }
        },
        clickTime() {
            this.$store.state.diagram.showTimePanel = true;
        },
        clickNow() {
            this.$store.state.timeCurrent = true;
            this.$store.dispatch('initTimeInputData', {from: 'diagram'})
            if(this.parentNode && this.parentNode.name == 'DiagramEdit') {
                this.$store.state.diagram.formDataEdited = true;
                this.$store.state.diagram.diagramTypeDataChanged = true;
            }
        },
        clickChoose() {
            if(this.parentNode && this.parentNode.name == 'DiagramEdit') {
                return;
            }
            this.$store.state.diagram.showChooseType = true;
        },
    }
}
</script>